import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Stack from 'react-bootstrap/Stack';
import { userPoolClientsReducer, initialState } from '../UserPoolClients.reducer';
import { UserPoolClientAction } from '../UserPoolClients.actions';
import { IUserPoolClient } from '../UserPoolClients.types';
import { getUserPoolClients } from '../UserPoolClients.service';

const UserPoolClientsLookup = (): JSX.Element => {
    var [state, dispatch] = React.useReducer(userPoolClientsReducer, initialState);

    const updateUserPoolId = (e: React.ChangeEvent<HTMLInputElement>): void => {
        dispatch({ type: UserPoolClientAction.UPDATE_USER_POOL_ID, userPoolId: e.currentTarget.value });
    };

    const submitForm = (e: React.FormEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        dispatch({ type: UserPoolClientAction.SUBMIT_FORM });
        getUserPoolClients(state.userPoolId, dispatch);
    };

    return(
        <Stack gap={3}>
            <h2>Lookup</h2>
            <Form>
                <Stack gap={3}>
                    <Form.Group>
                        <Form.Control
                            id='userPoolIdInput'
                            type='string'
                            placeholder='Enter User Pool Id'
                            value={state.userPoolId}
                            onChange={updateUserPoolId}
                            disabled={state.disabled}
                            />
                    </Form.Group>
                    <Form.Group>
                        <Button
                            variant='primary'
                            type='submit'
                            onClick={submitForm}
                            disabled={state.disabled}
                            >
                            Search
                        </Button>
                    </Form.Group>
                </Stack>
            </Form>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Client Id</th>
                        <th>Client Name</th>
                        <th>User Pool Id</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {state.searchResultLookup && state.searchResultLookup.map((value: IUserPoolClient, index: number) => {
                        return (
                            <tr key={`row-${index}`}>
                                <td key={`userPool-id-${index}`}>{value.clientId}</td>
                                <td key={`userPool-name-${index}`}>{value.clientName}</td>
                                <td key={`userPool-userPoolId-${index}`}>{value.userPoolId}</td>
                                <td key={`userPool-editCol-${index}`}><Button>Edit</Button></td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </Stack>
    );
};

export default UserPoolClientsLookup;